import React, { useState } from "react";
import { motion } from "framer-motion";
import { AiOutlineMenu, AiOutlineClose } from "react-icons/ai";
const Navbar = ({ navbar }) => {
  const hover = { translateY: -10, color: "#ca8a04" };
  const [nav, setNav] = useState(false);
  const parent = {
    hidden: {
      scale: 0,
      x: "-100vh",
    },
    visible: {
      x: 0,
      scale: 1,
      transition: { duration: 0.1, type: "tween" },
    },
  };
  const p = {
    hidden: {
      scale: 0,
      y: "-100vh",
    },
    visible: {
      y: 0,
      scale: 1,
      transition: { duration: 0.3, stiffness: 50 },
    },
  };

  return (
    <>
      <motion.div className={`hidden md:block  $  `}>
        <motion.div
          variants={p}
          initial="hidden"
          animate="visible"
          transition={{ duration: 1, ease: "easeOut" }}
          className={`text-3xl  z-40  bg-black top-0 shadow-md delay-300 ease-in-out p-4   w-full
    ${navbar ? "active fixed  animate-navanimate" : "absolute"} `}
        >
          <motion.nav className=" flex   capitalize items-center lg:w-4/5 mx-auto ">
            <h1>
              <img
                src={require("../data/rf.png")}
                alt=""
                className="w-14 h-14"
              />
            </h1>
            <ul className="flex ml-auto gap-8  justify-end items-center ">
              <motion.li whileHover={hover}>
                <a href="#home">home</a>
              </motion.li>
              <motion.li whileHover={hover}>
                <a href="#about">about</a>
              </motion.li>

              <motion.li whileHover={hover}>
                <a href="#projects">projects</a>
              </motion.li>
              <li>
                <motion.a
                  download
                  className=" hover:text-yellow-600  ring-white ring-2 hover:ring-yellow-600 transition-all ease-in-out duration-500   cursor-pointer rounded-md  px-2 capitalize "
                  href="./Fedi Rouatbi, Front-end Developer.pdf"
                >
                  resume
                </motion.a>
              </li>
            </ul>
          </motion.nav>
        </motion.div>
      </motion.div>
      <div className="block md:hidden">
        <div
          className="fixed top-0 right-0 m-4 cursor-pointer z-30 text-yellow-600 hover:text-yellow-800"
          onClick={() => setNav((prev) => !prev)}
        >
          {!nav ? <AiOutlineMenu size={30} /> : <AiOutlineClose size={30} />}
        </div>
        <motion.div
          variants={parent}
          animate={nav ? "visible" : "hidden"}
          className="fixed top-0 lef-0 h-full w-2/5  bg-black flex flex-col z-50 p-4 gap-10  "
        >
          <h1>
            <img src={require("../data/rf.png")} alt="" className="w-12 h-12" />
          </h1>
          <ul className="flex flex-col gap-5 capitalize justify-center">
            {["home", "about", "projects"].map((elm, i) => (
              <li key={i}>
                <a
                  href={`#${elm}`}
                  onClick={() => setNav((prev) => !prev)}
                  className="hover:text-yellow-800"
                >
                  {elm}
                </a>
              </li>
            ))}
          </ul>
        </motion.div>
      </div>
    </>
  );
};

export default Navbar;
